import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Preset Name", -1)
const _hoisted_3 = { class: "grey-form-card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3 add-star-to-field" }, "Score", -1)
const _hoisted_5 = { class: "grey-form-card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "scope-name-parent" }, [
  /*#__PURE__*/_createVNode("span", null, "MMSE")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "scope-name-parent" }, [
  /*#__PURE__*/_createVNode("span", null, "ADAScog")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Age", -1)
const _hoisted_9 = { class: "grey-form-card" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Sex", -1)
const _hoisted_11 = { class: "grey-form-card" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Male")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Female")
const _hoisted_14 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_slider = _resolveComponent("el-slider")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "100px",
      model: _ctx.form,
      rules: _ctx.rules,
      ref: "presetForm"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, {
            label: "Name",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                maxlength: 50,
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trim('name')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, { class: "parent-item parent-full-size" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Score Type",
                    class: "score-name"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "From",
                    prop: "score_mmse_from",
                    class: "score-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.score_mmse_from,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.score_mmse_from = $event)),
                        maxlength: 2,
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trim('score_mmse_from')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "To",
                    prop: "score_mmse_to",
                    class: "score-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.score_mmse_to,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.score_mmse_to = $event)),
                        maxlength: 2,
                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trim('score_mmse_to')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: " ",
            prop: "operator_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "operator-select",
                modelValue: _ctx.form.operator_type,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.operator_type = $event)),
                placeholder: "Operator"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "",
                    value: null
                  }),
                  _createVNode(_component_el_option, {
                    label: "And",
                    value: "And"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Or",
                    value: "Or"
                  }),
                  _createVNode(_component_el_option, {
                    label: "AND/OR",
                    value: "AndOr"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "parent-item parent-full-size" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Score Type",
                    class: "score-name"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "From",
                    prop: "score_adascog_from",
                    class: "score-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.score_adascog_from,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.score_adascog_from = $event)),
                        maxlength: 2,
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.trim('score_adascog_from')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "To",
                    prop: "score_adascog_to",
                    class: "score-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.score_adascog_to,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.score_adascog_to = $event)),
                        maxlength: 2,
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.trim('score_adascog_to')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_slider, {
                modelValue: _ctx.form.age,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.age = $event)),
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setAge($event))),
                range: "",
                min: 18,
                max: 120
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "parent-item parent-full-size" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "From",
                    prop: "age_from",
                    class: "age-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.age_from,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.age_from = $event)),
                        maxlength: 3,
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.trim('age_from')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "To",
                    prop: "age_to",
                    class: "age-value last-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.age_to,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.age_to = $event)),
                        maxlength: 3,
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.trim('age_to')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.form.sex_types,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.sex_types = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, { label: "M" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { label: "F" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode("div", _hoisted_14, [
      _createVNode("button", {
        class: "button secondary",
        onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"]))
      }, " Cancel "),
      _withDirectives(_createVNode("button", {
        class: "button",
        disabled: !_ctx.isRequiredFilled,
        onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"]))
      }, " Save ", 8, ["disabled"]), [
        [
          _directive_loading,
          _ctx.state.loading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ])
  ]))
}